import { Location } from 'history';
import * as React from 'react';
import * as queryString from 'query-string';

import { CreationParams, getOptionalCreationParams } from 'login-utils/stateUtils';
import * as loanEstimateUtils from './loanEstimateUtils';
import ConnectedLoanEstimateForm from './LoanEstimateForm/LoanEstimateForm';

interface LoanEstimateProps {
  location: Location;
}

class LoanEstimate extends React.Component<LoanEstimateProps, {}> {
  optionalParams: CreationParams;

  // istanbul ignore next: (UI-5482)
  constructor(props) {
    super(props);
    const { location } = props;
    const query = queryString.parse(location.search);

    this.optionalParams = getOptionalCreationParams(query, ['referrerId', 'loanType']);
  }

  render() {
    return (
      <div className="it-LoanEstimate">
        <ConnectedLoanEstimateForm onSubmit={loanEstimateUtils.submitEstimate(this.optionalParams)} />
      </div>
    );
  }
}

export default LoanEstimate;
